import { t } from 'services/translation';

export const isStripeField = (cardType) => {
  return ['cardNumber', 'cardExpiry', 'cardCvc', 'postalCode'].includes(
    cardType
  );
};

export const isStripeFieldsCompleted = (completedFields) => {
  return ['cardNumber', 'cardExpiry', 'cardCvc', 'postalCode'].every(
    (cardType) => completedFields.includes(cardType)
  );
};

export const stripeFieldErrors = {
  cardNumber: `${t('CARD_NUMBER_MUST_BE_COMPLETE')}`,
  cardExpiry: `${t('CARD_EXPIRATION_MUST_BE_COMPLETE')}`,
  cardCvc: `${t('CARD_SECURITY_CODE_MUST_BE_COMPLETE')}`,
  postalCode: `${t('POSTAL_CODE_MUST_BE_COMPLETE')}`,
};

export const stripeFields = [
  'cardNumber',
  'cardExpiry',
  'cardCvc',
  'postalCode',
];

export const stripeErrors = (fieldsCompleted) => {
  const stripeErrorsObject = {};
  stripeFields.forEach((field) => {
    if (!fieldsCompleted.includes(field)) {
      stripeErrorsObject[field] = stripeFieldErrors[field];
    }
  });
  return stripeErrorsObject;
};
